export default class Menu {

  constructor() {
    this.toggleSelector = document.querySelector('.menu-toggle');
    this.container = document.body;
    this.menu = document.querySelector('.mobile-menu');
    this.subMenus = this.menu ? this.menu.querySelectorAll('.menu-item-has-children > a, .menu-item-has-children > button') : null;
    this.isOpen = false;

    this.attachHandlers();
  }

  openMenu() {
    this.container.classList.add('mobile-nav-open');
    this.isOpen = true;

    document.dispatchEvent( new CustomEvent('mobile.menu.opened'));
  }

  closeMenu() {
    this.container.classList.remove('mobile-nav-open');
    this.isOpen = false;

    if(this.menu) {
      this.menu.scrollTop = 0;
    }
  }

  toggleMenu(event) {
    event && event.preventDefault();

    if( this.isOpen ) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  attachHandlers() {
    if( this.toggleSelector ) {
      this.toggleSelector.addEventListener('click', this.toggleMenu.bind(this));
    }

    if( this.subMenus ) {
      this.subMenus.forEach( button => {
        button.addEventListener('click', this.expandSubMenu.bind(this));
      })
    }
  }

  expandSubMenu(event) {
    event.preventDefault();

    let button = event.target;
    let subMenu = button.closest('li').querySelector('.sub-menu');

    button.classList.toggle('active');

    if(!subMenu.classList.contains('country-sub-menu')) {
      if (subMenu.style.maxHeight) {
        //close sub menus

        const subMenus = subMenu.querySelectorAll('.sub-menu');

        if(subMenus && subMenus.length > 0) {
          subMenus.forEach(m => this.setMaxHeight(m, null));
        }
        //close current sub menu
        this.setMaxHeight(subMenu, null);
      } else {
        this.setMaxHeight(subMenu, subMenu.scrollHeight);
      }
    }

    if(button.classList.contains('active') && subMenu.classList.contains('country-sub-menu')) {
      const activeLanguage = subMenu.querySelector('.active');
      if(activeLanguage) {
        activeLanguage.scrollIntoView();
      }
    }
  }

  setMaxHeight(menu, height)
  {
    let currentMaxHeight = parseInt(menu.style.maxHeight);
    menu.style.maxHeight = height ? height + 'px' : height;

    const parent = menu.parentNode.closest('.sub-menu');

    if(!parent) {
      return;
    }
    if(height) {
      this.setMaxHeight(parent, parent.scrollHeight + height);
    } else {
      if(!isNaN(currentMaxHeight)) {
        this.setMaxHeight(parent, parseInt(parent.style.maxHeight ) - currentMaxHeight);
      }
    }
  }
}
